module.exports = __webpack_public_path__ + "img/icon_graph_type_radio.58ec7510.svg";